import { registerApplication, start } from 'single-spa';
registerApplication({
    name: 'sprocket',
    app: () => import(/* webpackIgnore: true */ window.__SPROCKET_URL__),
    activeWhen: () => true,
});
start();
